import React, { useEffect, useState } from 'react';
import styles from './shSlider.module.scss';
import ArrowLeftIcon from "../../public/icons/arrowLeft.svg";
import ArrowRightIcon from "../../public/icons/arrowRight.svg";
import { Swiper } from 'swiper/react';
import useSize from "../../helper/hooks/shSize";

const ShSlider = ( {   children,
                       className = "",
                       caption = "",
                       loop = false,
                       captionOneLine = false,
                       fullScreen = false
                } ) => {


    const [ isMoreLeft, setIsMoreLeft ] = useState(false);
    const [ isMoreRight, setIsMoreRight ] = useState(true);


    const [ slider, setSlider ] = useState(null);

    const [ isXS, isSM, isMD ] = useSize();

    const swipe = (direction = 1.0) => {
        if (slider) {

            if (direction === 1.0) {
                slider.slideNext();
            } else {
                slider.slidePrev();
            }

            // if (isXS) {
            //     slider.slideTo(slider.activeIndex + ( 1 * direction));
            // } else if (isSM) {
            //     slider.slideTo(slider.activeIndex + (2 * direction));
            // } else {
            //     slider.slideTo(slider.activeIndex + (3 * direction));
            // }

        }
    };

    const toTheRight = () => {
        swipe(1.0);
    }

    const toTheLeft = () => {
        swipe(-1.0);
    };



    // @refresh reset
    return <>
            <div className={className + " " + styles.shSlider + " " }>
                {captionOneLine ?
                    <div className={fullScreen ? (styles.shSliderHeader + " px-3 d-flex align-items-center mb-4") : (styles.shSliderHeader + ' d-flex align-items-center mb-4')}>
                        <div className={"w-100 mr-4"}>
                            <h6>{caption}</h6>
                        </div>
                        <div className={(!isMoreRight && !isMoreLeft) ? " d-none " : (caption === "" ? " d-flex justify-content-center justify-items-center" : " d-flex justify-content-end justify-items-end mb-1")}>
                            <ArrowLeftIcon
                                className={'c-pointer svg-lobster mr-4 svg-24 ' + (!isMoreLeft ? styles.arrowDisabled : '')}
                                onClick={() => toTheLeft()}/>

                            <ArrowRightIcon
                                className={'c-pointer svg-lobster svg-24  ' + (!isMoreRight ? styles.arrowDisabled : '')}
                                onClick={() => toTheRight()}/>
                        </div>

                    </div>
                    :
                    <div className={fullScreen ? (styles.shSliderHeader + ' d-flex flex-column flex-sm-row mb-4 px-3') : (styles.shSliderHeader + ' d-flex flex-column flex-sm-row mb-4') }>
                        <div className={"mb-2 mb-sm-0 w-100 h6"}>
                            {caption}
                        </div>
                            <div className={(!isMoreRight && !isMoreLeft) ? " d-none " : (caption === "" ? " d-flex flex-row align-self-center mt-3 mt-sm-0" : " d-flex flex-row align-self-end mt-3 mt-sm-0 mb-1") }>
                                <ArrowLeftIcon
                                    className={'c-pointer svg-lobster mr-3 svg-24 ' + (!isMoreLeft ? styles.arrowDisabled : '')}
                                    onClick={() => toTheLeft()}/>

                                <ArrowRightIcon
                                    className={'c-pointer svg-lobster svg-24 ' + (!isMoreRight ? styles.arrowDisabled : '')}
                                    onClick={() => toTheRight()}/>
                            </div>
                    </div>
                }


                {/*<div className={styles.shSliderMoreWrapper}>*/}
                {/*    { isMoreLeft && <div className={styles.shSliderMoreLeft} /> }*/}
                {/*    { isMoreRight && <div className={styles.shSliderMoreRight} /> }*/}
                {/*</div>*/}

                <Swiper className={styles.swiper}
                        loop={loop}
                        spaceBetween={20}
                        slidesPerView={'auto'}
                        pagination={{ clickable: true }}
                        scrollbar={{ draggable: true }}
                        onReachEnd={ (e) => {
                            setIsMoreRight(false);
                        }}
                        onSlideChange={(e) => {
                            setIsMoreLeft(!e.isBeginning);
                            setIsMoreRight(!e.isEnd);
                        }}
                        onSwiper={setSlider}
                >
                    { children }
                </Swiper>
            </div>
        </>
        ;
}

export default ShSlider;
